export type StarterLanguage = "js" | "python";

/**
 * Maps a lesson's `starterCode` base name (such as `u3l6.starter` or
 * `apcsp/c1l1.starter`) to the candidate bundle keys for the requested
 * language. In Python mode the `.py` sibling is preferred, falling back to the
 * `.js` file when no Python translation exists yet.
 *
 * A trailing `.js` / `.py` on the input is tolerated, so older lesson configs
 * keep working. The returned keys are directory-relative; `assets.ts` resolves
 * them against the bundled `karelCode/` map.
 *
 * Kept free of build-time asset imports so the Node verification harness can
 * import it directly.
 */
export function starterCodeCandidates(
  starterCode: string,
  language: StarterLanguage,
): string[] {
  const base = starterCode.replace(/\.(js|py)$/i, "");
  if (language === "python") {
    return [`${base}.py`, `${base}.js`];
  }
  return [`${base}.js`];
}
